import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        fontSize: {
            small: 10,
            medium: 14,
            large: 16,
        },
        fontFamily: typography.fontFamily,
        height: {
            small: 16,
            medium: 32,
            large: 48,
        },
        gap: {
            small: 3,
            medium: 6,
            large: 9,
        },
        spikesItemSize: {
            small: 2,
            medium: 4,
            large: 6,
        },
        labelTop: {
            small: 4,
            medium: 8,
            large: 8,
        },
        color: {
            spikesItem: semantic.activeMode === 'dark' ? 'white' : 'black',
            neutral: semantic.text.stronger.neutral,
        },
        underlay: semantic.underlay.dark,
    };
}
